<template>
  <div
    v-if="collapsed"
    class="PasswordBox d-flex flex-column"
  >
    <b-button
      variant="secondary"
      class="PasswordBox__Button"
      squared
      @click="openPasswordBox"
    >
      Wachtwoord wijzigen
    </b-button>
  </div>
  <div
    v-else
    class="PasswordBox d-flex flex-column pt-3"
  >
    <div class="px-4">
      <Feedback
        v-if="feedback.show"
        :feedback="feedback"
      />
      <form @submit="handleSubmit">
        <label
          class="PasswordBox__Label"
          for="new-password"
        >
          Nieuw wachtwoord
        </label>

        <b-input
          id="new-password"
          ref="password"
          v-model="password"
          :disabled="busy"
          class="PasswordBox__Input"
        />
      </form>
      <p class="PasswordBox__Instruction text-muted mt-2">
        Minimaal 8 tekens: letters, hoofdletters, cijfers en optioneel speciale karakters (e.g. !@#$%^&amp;*). Na het aanpassen moet u opnieuw inloggen.
      </p>
    </div>
    <b-button
      squared
      :disabled="busy"
      variant="cta"
      class="PasswordBox__Button mt-3"
      @click="handleSubmit"
    >
      Wachtwoord wijzigen
    </b-button>
  </div>
</template>

<script>

import Feedback from '@/components/form/Feedback.vue'

export default {
  name: 'PasswordBox',
  components: { Feedback },
  data() {
    return {
      busy: false,
      collapsed: true,

      password: '',
      feedback: {
        show: false,
        message: '',
        variant: 'danger',
      },
    }
  },
  watch: {
    busy(busy) {
      this.$emit('processing', { busy })
    },
  },
  methods: {
    openPasswordBox() {
      this.collapsed = false

      // Focus password input field
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleSubmit: async function(e) {
      e.preventDefault()

      if (this.password === '') {
        this.feedback = {
          show: true,
          message: 'Vul een wachtwoord in',
          variant: 'danger',
        }
        return
      }

      this.busy = true

      // TODO: CBAPI - TEST - Fix user/password-reset response on error
      const response = await this.$cbapi.user.resetPassword({
        password: this.password
      })

      if (response.message === 'success') {
        this.feedback = {
          show: true,
          message: 'Geslaagd. U wordt doorverwezen in 3 seconden.',
          variant: 'success',
        }

        setTimeout(this.logout, 3000)
      }
      else {
        let message = 'Er ging iets mis. Neem a.u.b. contact op.'

        if (response.message === 'PasswordStrengthError: Password is too weak') {
          message = 'Dit wachtwoord is niet veilig genoeg'
        } else if (response.message === 'PasswordHistoryError: Password has previously been used') {
          message = 'Dit wachtwoord is eerder gebruikt, kies een nieuw wachtwoord'
        } else if (response.message === 'Blacklisted') {
          message = 'Dit wachtwoord is niet toegestaan'
        } else if (response.message === 'Password is required') {
          message = 'Vul een wachtwoord in'
        }

        this.feedback = {
          show: true,
          message,
          variant: 'danger',
        }
        this.busy = false
      }
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      })
    },
  },
}
</script>

<style lang="scss">

.PasswordBox {
  color: #041E42;
  background: #EEEEEF;

  .PasswordBox__Button {
    padding: 0.75rem;
  }
  .PasswordBox__Instruction {
    font-size: 0.9rem;
  }
}

</style>
